import { render, staticRenderFns } from "./lrSpinner.vue?vue&type=template&id=1b31aff1&"
import script from "./lrSpinner.vue?vue&type=script&lang=js&"
export * from "./lrSpinner.vue?vue&type=script&lang=js&"
import style0 from "./lrSpinner.vue?vue&type=style&index=0&id=1b31aff1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports